import React from "react"
import { rhythm } from "../utils/typography"
import Footer from "./Footer"
import Header, {HeaderDivWithOutSVG} from "./Header";
import styled from "styled-components";

import useScrollToTop from "../hooks/useScrollToTop";
import {ArrowUpCircle} from "@styled-icons/bootstrap/ArrowUpCircle";


const ScrollToTopButton = styled.button `
  width: 40px;
  height: 40px;
  cursor:pointer;
  display:flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--color-secondary);
  border:none;
  outline:none;
  color: var(--color-background);
  position: fixed;
  bottom: 8%;
  right:8%;
  z-index: 9999;
  willChange: transform;
  transform: translateY(0px);
  transition: transform 100ms ease-in-out;
  :disabled{
    display:none;
    background: red;
  }
  :hover{
    transform: translateY(-4px);
  }
  :active{
    transform: translateY(4px);
    transition: transform 34ms;
  }
`


const Layout = ({ children, location }) => {
  const [isBtnVisible, scrollToTop] = useScrollToTop();
  
  return (
    <div>
      <Header />
      <div
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(36),
          padding: `0 ${rhythm(1)}`,
        }}>
          <ScrollToTopButton disabled={!isBtnVisible} onClick={scrollToTop}>
            <ArrowUpCircle size="24"/>
          </ScrollToTopButton>
        <main style={{ marginTop: 0,  }}>{children}</main>
      </div>
      <Footer />
    </div>
  )
}


export const AnotherLayout = ({children}) => {
  const [isBtnVisible, scrollToTop] = useScrollToTop();

  return (
    <div>
        <HeaderDivWithOutSVG />
        <div
          style={{
            marginLeft: `auto`,
            marginRight: `auto`,
            maxWidth: rhythm(36),
            padding: `0 ${rhythm(1)}`,
          }}>
          <ScrollToTopButton disabled={!isBtnVisible} onClick={scrollToTop}>
            <ArrowUpCircle size="24"/>
          </ScrollToTopButton>
          <main style={{ marginTop: 0,  }}>{children}</main>
        </div>
        <Footer />
    </div>
)};

export default Layout;
